import { render } from "./Forgot-Password-Confirmation.vue?vue&type=template&id=02cdd6c9&scoped=true"
import script from "./Forgot-Password-Confirmation.vue?vue&type=script&lang=js"
export * from "./Forgot-Password-Confirmation.vue?vue&type=script&lang=js"

import "./Forgot-Password-Confirmation.vue?vue&type=style&index=0&id=02cdd6c9&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cdd6c9"]])

export default __exports__